import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { CategoriaProduto } from '../../types/estoque';
import { categoriasProdutoService } from '../../services';

const fields: ResourceField<CategoriaProduto>[] = [
  { name: 'nome', label: 'Nome', required: true },
  { name: 'descricao', label: 'Descricao' },
  {
    name: 'ativo',
    label: 'Ativo',
    render: ({ value, onChange }) => (
      <div className="d-flex flex-column">
        <label className="form-label">Ativo</label>
        <select
          className="form-select"
          value={value === true ? 'true' : value === false ? 'false' : ''}
          onChange={(e) => onChange(e.target.value === '' ? undefined : e.target.value === 'true')}
        >
          <option value="">Selecione</option>
          <option value="true">Sim</option>
          <option value="false">Nao</option>
        </select>
      </div>
    ),
  },
];

export const TiposProdutoFormPage: React.FC = () => (
  <ResourceFormPage
    title="Categoria de produto"
    description="Cadastre ou edite categorias de produto."
    fields={fields}
    service={categoriasProdutoService}
    redirectPath="/admin/estoque/tipos-produto"
    cancelPath="/admin/estoque/tipos-produto"
  />
);
